import { render, staticRenderFns } from "./ReservationDetail.vue?vue&type=template&id=5bfcb29c&"
import script from "./ReservationDetail.ts?vue&type=script&lang=js&"
export * from "./ReservationDetail.ts?vue&type=script&lang=js&"
import style0 from "./ReservationDetail.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports